module.exports = __webpack_public_path__ + "img/data.d1daec0b.png";